@use './variables' as *;
@use '../../styles/abstracts/break-points' as *;

:host {
  display: $radio-button-host-display;
}

.radio-button {
  display: $radio-button-display;
  align-items: $radio-button-align-items;
  position: relative;
  min-height: $radio-button-outer-circle-height;
  padding-left: $radio-button-padding-left;
  margin-top: $radio-button-margin-top;
  margin-right: $radio-button-margin-right;
  margin-bottom: $radio-button-margin-bottom;
  margin-left: $radio-button-margin-left;
  box-sizing: $radio-button-box-sizing;
  &:not(.disabled) {
    cursor: $radio-button-cursor;
  }
  &::before,
  &::after {
    position: absolute;
    content: '';
    box-sizing: $radio-button-box-sizing;
  }
  &::before {
    width: $radio-button-outer-circle-width;
    height: $radio-button-outer-circle-height;
    top: $radio-button-outer-circle-top;
    left: $radio-button-outer-circle-left;
    border: $radio-button-outer-circle-border;
    border-radius: $radio-button-outer-circle-border-radius;
    background-color: $radio-button-outer-circle-background-color;
  }

  &::after {
    display: none;
    width: $radio-button-inner-circle-width;
    height: $radio-button-inner-circle-height;
    top: $radio-button-inner-circle-top;
    left: $radio-button-inner-circle-left;
    border-radius: $radio-button-inner-circle-border-radius;
    background-color: $radio-button-inner-circle-background-color;
  }
  &[aria-checked]::after {
    display: block;
  }
  &:focus {
    outline: none;
    &:not(.disabled)::before {
      box-shadow: 0 0 0 $radio-button-outer-circle-focus-width
        $radio-button-outer-circle-focus-color;
    }
  }
  &:hover::before {
    background-color: $radio-button-outer-circle-hover-background-color;
  }
  &.disabled::before {
    border: $radio-button-outer-circle-disabled-border;
    background-color: $radio-button-outer-circle-disabled-background-color;
  }
  .label {
    color: $radio-button-label-color;
    font-family: $radio-button-label-font-family;
    font-weight: $radio-button-label-font-weight;
    font-size: $radio-button-label-font-size;
    line-height: $radio-button-label-line-height;
  }
  .required-mark {
    color: $radio-button-mark-required-color;
  }
  &.status-error {
    &::before {
      border: $radio-button-checkmark-status-error-border;
    }
    .label {
      color: $radio-button-label-status-error-color;
    }
  }
}

@media (max-width: $breakpoint-mobile) {
  .radio-button {
    padding-left: $mobile-radio-button-padding-left;
    min-height: $mobile-radio-button-outer-circle-height;
    &::before {
      width: $mobile-radio-button-outer-circle-width;
      height: $mobile-radio-button-outer-circle-height;
      top: $mobile-radio-button-outer-circle-top;
      left: $mobile-radio-button-outer-circle-left;
    }
    &::after {
      width: $mobile-radio-button-inner-circle-width;
      height: $mobile-radio-button-inner-circle-height;
      top: $mobile-radio-button-inner-circle-top;
      left: $mobile-radio-button-inner-circle-left;
    }
  }
}
